module.exports = __webpack_public_path__ + "img/gift4-01-c11-t1.c6fc1647.png";